import React from 'react'
import { string, bool } from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

function ProTipItem({ heading, tip, isChecked = false }) {
  return (
    <div className="pro-tip-item">
      {isChecked ? (
        <Icon type={['far', 'check']} color="green" />
      ) : (
        <Icon type={['far', 'times']} color="red" />
      )}
      <div className="pro-tip-item__content">
        <div className="pro-tip-item__heading">{heading}</div>
        <div className="pro-tip-item__tip cgt-legacy-color-white-40">{tip}</div>
      </div>
    </div>
  )
}

ProTipItem.propTypes = {
  heading: string.isRequired,
  tip: string.isRequired,
  isChecked: bool,
}

export default ProTipItem
